<template>
    <div class="no-weixin-account-data">
        <v-icon
            class="no-data-image"
            name="icon-weixin"
        />
        <div class="no-data-msg">
            {{ $t('未绑定任何公众号,暂无法使用此功能') }}
        </div>
        <div class="no-data-btn">
            <v-button
                @click="goAccountInfo"
                kind="primary"
            >
                {{ $t('去绑定') }}
            </v-button>
        </div>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
const req = require.context('../assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);
export default {
    name: '',
    props: {
        currAccountInfo: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {

        };
    },
    computed: {
        isCurrAccountAble() {
            return this.currAccountInfo && this.currAccountInfo.enabledCond;
        },
    },
    methods: {
        goAccountInfo() {
            window.open('/mp/accountInfo', '_blank');
        },
    },
};
</script>

<style lang="less" scoped>
.no-weixin-account-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 200px;
    .no-data-image {
        width: 69px;
        height: 100px;
    }
    .no-data-msg {
        margin-bottom: var(--spacing-loose);
        color: var(--color-text-caption);
    }
}
</style>
